// extracted by mini-css-extract-plugin
export default {"order-view":"takeOrder_order-view__S3crC","order-container":"takeOrder_order-container__--Gxv"};